import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Grid, Box, Chip, TextField } from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";
import * as DbValueConstants from "utilities/DbValueConstants";
import * as CommonConstants from "utilities/CommonConstants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            margin: theme.spacing(5),
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        cautionMessage: {
            fontSize: `small`,
            color: `red`,
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
}

/**
 * 予約確認コンポーネント
 * 予約確認画面のコンポーネント
 */
export const ConfirmParts: React.FC<Props> = (props) => {
    const { booking } = props;
    const classes = useStyles();

    return (
        <div className={classes.form}>
            <Grid container item xs={12}>
                {booking.bookingDetails?.map((data) => {
                    return (
                        <Box key={data.solventId} m={2}>
                            <Chip
                                label={
                                    data.name +
                                    ` ` +
                                    data.subName +
                                    ` ／ ` +
                                    data.capacity +
                                    (data.unit === DbValueConstants.UNIT_ID_L
                                        ? CommonConstants.UNIT_NAME_L
                                        : CommonConstants.UNIT_NAME_KG)
                                }
                                style={{ background: data.colorCode }}
                            />
                        </Box>
                    );
                })}
            </Grid>
            <div>
                <TextField
                    margin="dense"
                    id="laboratory"
                    label="研究室名（必須）"
                    type="text"
                    value={booking.subscriberLaboratoryName}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="name"
                    label="氏名（必須）"
                    type="text"
                    value={booking.subscriberName}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="email"
                    label="1.メールアドレス（必須）"
                    type="email"
                    value={booking.subscriberMailAddress}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="email_opt"
                    label="2.メールアドレス（任意）"
                    type="email"
                    value={booking.subscriberMailAddressOption}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="tel"
                    label="電話番号（任意）"
                    type="text"
                    value={booking.subscriberTel}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    id="memo"
                    label="備考"
                    type="text"
                    value={booking.subscriberMemo}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </div>
            <div className={classes.cautionMessage}>
                <br />
                <div>【注意事項】</div>
                <div>教員確認印のある出庫伝票、手袋、保護メガネは各自持参してください。</div>
                <div>一斗缶の持出しには台車が必要です。</div>
                <div>5分以上遅れた場合は、キャンセルとなります。</div>
                <div>スマートフォン等の電子機器の持ち込みは出来ません。</div>
            </div>
        </div>
    );
};
